export default {
  "title": "นักล่าปีศาจ",
  "intro": "สะสมการส่งพลังไฟให้ถึงเป้าหมาย เพื่อรับรางวัลตามแต่ละระดับ ยิ่งร่วมส่งมาก รางวัลก็ยิ่งคุ้ม!",
  "login": "เข้าสู่ระบบ",
  "logout": "ออกจากระบบ",
  "howToPlay": "วิธีการเล่น",
  "contributeDesc": "สะสมการส่งพลังไฟให้ถึงเป้าหมาย เพื่อรับรางวัลตามแต่ละระดับ ยิ่งร่วมส่งมาก รางวัลก็ยิ่งคุ้ม!",
  "account": "ID บัญชี",
  "code": "รหัสยืนยัน",
  "sendCode": "รหัสยืนยันถูกส่งยังเมลในเกม",
  "codeSent": "ส่งรหัสยืนยันแล้ว โปรดตรวจสอบกล่องจดหมายในเกม",
  "submit": "ยืนยัน",
  "cancel": "ยกเลิก",
  "ok": "ตกลง",
  "rewardConfirm": "ยืนยัน",
  "available": "จำนวนกระสุนปืนใหญ่ที่เหลืออยู่",
  "total": "โจมตีสะสม",
  "ghostDefeated": "ปราบปีศาจแล้ว",
  "globalTitle": "ความคืบหน้าการกำจัดผี",
  "strikeTitle": "โจมตี",
  "strike": "ยิงปืนใหญ่!!!",
  "strikeRecord": "ยิงปืนใหญ่",
  "taskTitle": "ศึกต่อสู้ในสุสาน",
  "missionClaimed": "รับแล้ว",
  "missionCompleted": "สามารถรับได้",
  "missionIncomplete": "ยังไม่สำเร็จ",
  "share": "แชร์",
  "sharing": "กำลังแชร์",
  "shareOk": "แชร์สำเร็จ",
  "milestoneTitle": "เป้าหมายส่วนตัว",
  "times": "เวลา",
  "recordTitle": "ประวัติการรับรางวัล",
  "recordDialogTitle": "ประวัติการรับรางวัล",
  "recordReward": "รางวัล",
  "recordTime": "เวลารับรางวัล",
  "refresh": "รีเฟรช",
  "empty": "ยังไม่มีข้อมูล",
  "receive": "สามารถรับได้",
  "received": "รับแล้ว",
  "notReady": "ยังไม่สำเร็จ",
  "locked": "ยังไม่ปลดล็อก",
  "unlocked": "สามารถรับได้",
  "rewardTitle": "รางวัล",
  "phase": {
    "not_start": "กิจกรรมยังไม่เริ่ม",
    "play": "กิจกรรมกำลังดำเนินอยู่",
    "view_only": "กิจกรรมสิ้นสุดแล้ว",
    "closed": "ปิดหน้าแล้ว"
  },
  "actTime": {
    "notStart": "กิจกรรมยังไม่เริ่ม",
    "ended": "กิจกรรมสิ้นสุดแล้ว",
    "startCountdown": "นับถอยหลังก่อนเริ่ม",
    "day": "วัน"
  },
  "taskCycle": {
    "daily": "ภารกิจรายวัน",
    "weekly": "ภารกิจรายสัปดาห์"
  },
  "tasks": {
    "hw_daily_login": "ล็อกอินรายวัน",
    "hw_daily_play_any_1": "เล่นโหมดใดก็ได้ 1 ครั้ง",
    "hw_daily_play_any_3": "เล่นโหมดใดก็ได้ 3 ครั้ง",
    "hw_daily_mojin_3": "เล่นโหมด ล่าสมบัติ 3 ครั้ง",
    "hw_weekly_share": "แชร์ไปยังโซเชียล"
  },
  "props": {
    "90301916": "[กรอบอวตาร] ระเบิดน้ำตาล",
    "70100101": "เพชรทอง",
    "70100011": "ทอง",
    "50108900": "Canorus (3 วัน)",
    "70100004": "การ์ดคะแนน",
    "80103001": "Rank Protection",
    "10301029": "เคียว-วันสิ้นโลก (3 วัน)",
    "80102101": "ตั๋วทองสำหรับสุ่ม",
    "82101002": "Flower",
    "80202003": "บัตรอัพเกรด Lv.3",
    "82101003": "Lollipop",
    "81010999": "เหรียญพัฒนาสากล",
    "70100013": "Mystic Voucher",
    "70100014": "กุญแจลึกลับ",
    "10101086": "AK15-ฤดูเก็บเกี่ยว"
  },
  "footer": {
    "privacyPolicy": "นโยบายความเป็นส่วนตัว",
    "userAgreement": "ข้อตกลงผู้ใช้",
    "customerService": "กรุณาติดต่อเราทางอีเมลที่ ministarcustomerservice{'@'}gmail.com"
  },
  "error": {
    "code401": "การเข้าสู่ระบบหมดอายุ",
    "code1001": "พารามิเตอร์ไม่ถูกต้อง",
    "code1004": "โปรดลองอีกครั้ง",
    "code2001": "กิจกรรมยังไม่เริ่ม",
    "code2002": "กิจกรรมสิ้นสุดแล้ว",
    "code2003": "ปิดหน้าแล้ว",
    "code2201": "ภารกิจยังไม่เสร็จ",
    "code2202": "รับรางวัลไปแล้ว",
    "code2203": "ยังไม่ได้ตั้งค่าภารกิจ",
    "code2301": "ไม่มีจำนวนโจมตี",
    "code2401": "ยังไม่ปลดล็อกขั้นนี้",
    "code2402": "รับรางวัลไปแล้ว",
    "code2403": "ไม่พบขั้นนี้",
    "code2501": "ไม่ตรงเงื่อนไข",
    "code2502": "รับไปแล้ว",
    "code2503": "ไม่พบเป้าหมาย",
    "code2801": "รับรางวัลไปแล้ว",
    "code429": "คำขอถี่เกินไป"
  },
  "howToPlayBody": "🎃 นักล่าปีศาจ｜ร่วมมือกันกำจัดผีตัวใหญ่\n\nในคืนฮาโลวีน ผีตัวมหึมาตัวหนึ่งบุกเข้ามาในโลกของ Mini World Royale ทั้งทำหน้าดุร้ายและสร้างความวุ่นวายไปทั่วทั้งเซิร์ฟเวอร์! ทอม, โมน่า, หลิงหยู และ สตาร์รี่ เมก้า ขอระดมพลเหล่า นักล่าทุกคน ทั่วทั้งเซิร์ฟเวอร์ — รวมพลังยิง เปิดฉากยิงครั้งแล้วครั้งเล่า ค่อย ๆ ทำลายหลอด HP ของผีตัวใหญ่ ร่วมมือกันกำจัดผีตัวนี้และปกป้องคืนฮาโลวีนเอาไว้!\n\n📅 ระยะเวลากิจกรรม\nระยะเวลาเข้าร่วม: 23 ตุลาคม – 9 พฤศจิกายน (GMT+7)\nระยะเวลารับรางวัล/แลกรางวัล: ตั้งแต่เริ่มกิจกรรม – 16 พฤศจิกายน (GMT+7)\n※ โปรดรับรางวัลภายในระยะเวลาที่กำหนด หากพ้นกำหนดจะถือว่าสละสิทธิ์\n\n🔥 วิธีเล่น? 3 ขั้นตอนกำจัดผีตัวใหญ่\n\nขั้นตอนที่ 1: รับจำนวนกระสุนปืนใหญ่\nเข้าสู่โหมด “ศึกต่อสู้ในสุสาน” และทำภารกิจประจำวัน / ประจำสัปดาห์ให้สำเร็จ เพื่อรับจำนวนครั้งในการโจมตี!\n\nขั้นตอนที่ 2: ยิงเลย! โจมตีผีตัวใหญ่\nคลิก “ยิงปืนใหญ่!!!” เพื่อโจมตีผีตัวมหึมา! ทุกครั้งที่คุณยิง จะลด HP ของผีตัวใหญ่ที่เป็น HP รวมของทั้งเซิร์ฟเวอร์ทันที พร้อมสะสมจำนวนครั้งในการโจมตีของคุณเอง ร่วมมือกับนักล่าทั่วทั้งเซิร์ฟเวอร์ เพื่อยิงจนหลอด HP ของผีตัวใหญ่หมดลง! (จำนวนครั้งในการยิงที่ใช้ไม่หมดสามารถเก็บไว้ใช้ในวันถัดไปได้ ไม่เสียเปล่า)\n\nขั้นตอนที่ 3: ปลดล็อกรางวัล\nรางวัลเซิร์ฟเวอร์: เมื่อ HP รวมของทั้งเซิร์ฟเวอร์ลดลงถึง 25% / 50% / 75% / 100% ผู้เล่นทุกคนที่เข้าร่วมกำจัดผีจะสามารถปลดล็อกรางวัลในแต่ละช่วงได้! เมื่อ HP ถูกลดจนหมดและผีตัวใหญ่ถูกกำจัดโดยผู้เล่นทั้งเซิร์ฟเวอร์ ทุกคนจะได้รับรางวัลใหญ่สุดท้ายร่วมกัน!\n\nรางวัลส่วนบุคคล: จำนวนครั้งในการโจมตีที่คุณสะสมด้วยตัวเอง ยังสามารถปลดล็อก “รางวัลลับ ส่วนบุคคล” เพิ่มเติมได้ รับรางวัลไปทีละขั้น ยิ่งโจมตีมาก ก็ยิ่งได้รับมาก!\n\n🏆 บันทึกของฉัน\nการโจมตีทั้งหมดและรางวัลที่เคยได้รับ สามารถตรวจสอบได้ที่ “ประวัติรางวัล”",
  "shareTitle": "เลี้ยงหรือหลอก!!!",
  "shareContent": "คืนฮาโลวีนมาเยือน กำจัดเหล่าผีเพื่อร่วมแบ่งรางวัลใหญ่ทั้งเซิร์ฟเวอร์\nอย่าปล่อยให้รางวัลที่ได้มาแล้วแอบหลุดมือไป",
  "accountPlaceholder": "กรุณากรอกบัญชี",
  "codePlaceholder": "กรุณากรอกรหัสยืนยัน"
}
